// src/components/dashboard/WalletCard.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { C } from '../../styles/tokens';

const TRANSACTIONS = [
  { type: 'in',  label: 'Referral Bonus',      amount: '+50 ONT',  time: '2h ago'  },
  { type: 'in',  label: 'Job Completion',       amount: '+200 ONT', time: '1d ago'  },
  { type: 'out', label: 'Training Enrollment',  amount: '-30 ONT',  time: '3d ago'  },
  { type: 'in',  label: 'Welcome Bonus',        amount: '+100 ONT', time: '5d ago'  },
];

const ACTIONS = [
  { icon: '⬆️', label: 'Send'    },
  { icon: '⬇️', label: 'Receive' },
  { icon: '🔄', label: 'Convert' },
  { icon: '↗️', label: 'Withdraw'},
];

export default function WalletCard() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard?.writeText('7xKp3r8Lm9mNq4wQsT2kRt');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
      {/* Balance header */}
      <div style={{
        padding: '22px 22px 18px',
        background: `linear-gradient(135deg, ${C.navy}80, ${C.violet}40)`,
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', top: -40, right: -40, width: 140, height: 140, borderRadius: '50%', background: `${C.magenta}12`, filter: 'blur(30px)' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px', position: 'relative' }}>
          <div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,.4)', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', marginBottom: '4px' }}>
              ONT Wallet
            </div>
            <div className="syne" style={{ fontSize: '28px', fontWeight: 800, lineHeight: 1 }}>
              1,240 <span style={{ fontSize: '14px', color: C.magenta }}>ONT</span>
            </div>
            <div style={{ fontSize: '12px', color: 'rgba(255,255,255,.38)', marginTop: '3px' }}>
              ≈ $186.00 USDT
            </div>
          </div>
          <div style={{ width: '42px', height: '42px', borderRadius: '12px', background: `linear-gradient(135deg, ${C.magenta}, ${C.violet})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
            🪙
          </div>
        </div>

        {/* Wallet address */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 12px', background: 'rgba(0,0,0,.25)', borderRadius: '9px', position: 'relative' }}>
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,.45)', flex: 1, fontFamily: 'monospace' }}>
            7xKp...r8Lm9mNq4wQsT
          </span>
          <button
            onClick={copy}
            style={{
              fontSize: '11px', padding: '3px 9px',
              background: copied ? 'rgba(0,208,132,.2)' : 'rgba(255,255,255,.1)',
              border: 'none', borderRadius: '6px',
              color: copied ? C.success : 'white',
              cursor: 'pointer', fontWeight: 600, transition: 'all .2s',
            }}
          >
            {copied ? '✓ Copied' : 'Copy'}
          </button>
        </div>
      </div>

      {/* Action buttons */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1px', background: 'rgba(255,255,255,.04)' }}>
        {ACTIONS.map(a => (
          <button
            key={a.label}
            onClick={() => navigate('/wallet')}
            style={{ padding: '13px 8px', background: C.surface2, border: 'none', color: 'white', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', transition: 'background .2s' }}
            onMouseEnter={e => { e.currentTarget.style.background = C.surface3; }}
            onMouseLeave={e => { e.currentTarget.style.background = C.surface2; }}
          >
            <span style={{ fontSize: '18px' }}>{a.icon}</span>
            <span style={{ fontSize: '10px', fontWeight: 600, color: 'rgba(255,255,255,.5)' }}>{a.label}</span>
          </button>
        ))}
      </div>

      {/* Recent transactions */}
      <div style={{ padding: '18px 20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
          <span className="syne" style={{ fontSize: '14px', fontWeight: 700 }}>Recent</span>
          <span onClick={() => navigate('/wallet')} style={{ fontSize: '12px', color: C.magenta, cursor: 'pointer' }}>View all</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {TRANSACTIONS.map((tx, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', borderRadius: '9px', background: 'rgba(255,255,255,.02)', border: '1px solid rgba(255,255,255,.05)' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: tx.type === 'in' ? 'rgba(0,208,132,.12)' : 'rgba(239,68,68,.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', flexShrink: 0 }}>
                {tx.type === 'in' ? '⬇️' : '⬆️'}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '13px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tx.label}</div>
                <div style={{ fontSize: '10px', color: 'rgba(255,255,255,.3)' }}>{tx.time}</div>
              </div>
              <span style={{ fontSize: '13px', fontWeight: 700, color: tx.type === 'in' ? C.success : C.danger, flexShrink: 0 }}>
                {tx.amount}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
